import { render, staticRenderFns } from "./club-list.vue?vue&type=template&id=5a1ae599&scoped=true"
import script from "./club-list.vue?vue&type=script&lang=js"
export * from "./club-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ae599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1ae599')) {
      api.createRecord('5a1ae599', component.options)
    } else {
      api.reload('5a1ae599', component.options)
    }
    module.hot.accept("./club-list.vue?vue&type=template&id=5a1ae599&scoped=true", function () {
      api.rerender('5a1ae599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clubs/club-list.vue"
export default component.exports